/*
  VEYNOU - Thumbnails der Farbauswahl aktuell halten.

  Auf der Produktseite zeigt jeder Farb-Swatch ein kleines Produktbild. Welches
  Bild richtig ist, haengt von den uebrigen gewaehlten Optionen ab: Bei der
  Eden Halskette gehoert zu "14kt. Gelbgold" ein anderes Foto, je nachdem ob
  1,00ct. oder 2,00ct. gewaehlt ist.

  Beim Seitenaufruf erledigt das Liquid (snippets/product-variant-picker.liquid).
  Wechselt die Kundin die Option aber im laufenden Betrieb, laedt das Theme nur
  Preis, SKU und Lieferzeit nach - die Thumbnails blieben stehen. Dieses Skript
  zieht sie nach, ohne zusaetzlichen Serveraufruf: Die Variantendaten liegen
  bereits als JSON im Picker.
*/
(function () {
  'use strict';

  var WIDTH = 300;

  function variantData(picker) {
    var script = picker.querySelector('script[type="application/json"]');
    if (!script) return null;
    try {
      var data = JSON.parse(script.textContent);
      return Array.isArray(data) ? data : null;
    } catch (e) {
      return null;
    }
  }

  // Aktuell gewaehlte Optionswerte, Index 0 = Option 1.
  function selectedOptions(picker) {
    var selected = [];
    picker.querySelectorAll('fieldset[data-option-index]').forEach(function (fieldset) {
      var position = parseInt(String(fieldset.dataset.optionIndex).replace('option', ''), 10);
      if (!position) return;
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked) selected[position - 1] = checked.value;
    });
    return selected;
  }

  /*
    Dieselbe Regel wie im Liquid: gesucht ist die Variante, die den Wert des
    Swatches an dessen Optionsposition traegt und in allen anderen Optionen der
    aktuellen Auswahl entspricht. Gibt es diese Kombination nicht (etwa weil eine
    Groesse in dieser Farbe fehlt), nehmen wir die erste Variante mit dem Wert.
  */
  function matchVariant(variants, position, value, selected) {
    var index = position - 1;
    var fallback = null;

    for (var i = 0; i < variants.length; i++) {
      var options = variants[i].options || [];
      if (options[index] !== value) continue;
      if (!fallback) fallback = variants[i];

      var matchesRest = true;
      for (var j = 0; j < options.length; j++) {
        if (j === index) continue;
        if (selected[j] !== undefined && options[j] !== selected[j]) {
          matchesRest = false;
          break;
        }
      }
      if (matchesRest) return variants[i];
    }
    return fallback;
  }

  function sizedUrl(src) {
    if (!src) return null;
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', String(WIDTH));
      return parsed.href;
    } catch (e) {
      return url;
    }
  }

  function updatePicker(picker) {
    var variants = variantData(picker);
    if (!variants) return;
    var selected = selectedOptions(picker);

    picker.querySelectorAll('fieldset[data-option-index]').forEach(function (fieldset) {
      var position = parseInt(String(fieldset.dataset.optionIndex).replace('option', ''), 10);
      if (!position) return;

      fieldset.querySelectorAll('label.color__swatch').forEach(function (label) {
        var image = label.querySelector('img');
        if (!image) return;

        var input = label.getAttribute('for') ? document.getElementById(label.getAttribute('for')) : null;
        var value = input ? input.value : label.getAttribute('title');
        if (!value) return;

        var variant = matchVariant(variants, position, value, selected);
        var featured = variant && variant.featured_image;
        var next = featured ? sizedUrl(featured.src) : null;
        if (!next) return;

        if (image.currentSrc !== next && image.getAttribute('src') !== next) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.setAttribute('src', next);
          if (featured.alt) image.setAttribute('alt', featured.alt);
        }
      });
    });
  }

  function updateAll() {
    document.querySelectorAll('variant-radios, variant-selects').forEach(updatePicker);
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('variant-radios, variant-selects')) {
      updateAll();
    }
  });

  // Das Theme meldet sich, wenn es die Sektion nachgeladen hat.
  document.addEventListener('productInfo:loaded', updateAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
})();
